import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import { formatName } from '../utils/StringUtils';

const sanitise = ({complianceId, skillId, userId, completed, ...rest}) => ({
    complianceId: Number(complianceId),
    skillId: Number(skillId),
    userId: Number(userId),
    completed: !!Number(completed),
    ...rest
});

const getRemoveFilter = ({complianceId, skillId, userId}) => (item) => (
    (!complianceId || (item.complianceId !== complianceId)) &&
    (!skillId || (item.skillId !== skillId)) &&
    (!userId || (item.userId !== userId))
);

const getReducer = (type) => {
    switch (type) {
        case 'user':
            return (ac, {userId, completed, ...rest}) => {
                const userData = ac[userId] ? {
                    ...ac[userId],
                    completed: ac[userId].completed + (completed ? 1 : 0)
                } : {
                    id: userId,
                    name: formatName(rest),
                    completed: (completed ? 1 : 0),
                };
                return {
                    ...ac,
                    [userId]: userData
                }
            };
        case 'skill':
            return (ac, {skillId, skillName, isTrainerSkill, completed, ...rest}) => {
                const skillData = ac[skillId] ? {
                    ...ac[skillId],
                    completed: ac[skillId].completed + (completed ? 1 : 0)
                } : {
                    id: skillId,
                    name: skillName,
                    isTrainerSkill,
                    completed: (completed ? 1 : 0),
                };
                return {
                    ...ac,
                    [skillId]: skillData
                }
            };
        default:
            return (ac) => ac;
    }
};

class ComplianceProgressStore extends ReduceStore {

    getInitialState() {
        return { isFetching: false, stats: [], error: null };
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getByCompliance(id) {
        return this.getState().stats.filter(({complianceId}) => complianceId === id);
    }

    getProgressByCompliance(id, type) {
        const data = this.getByCompliance(id);
        const map = data.reduce(getReducer(type), {});
        return Object.values(map);
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.COMPLIANCE_PROGRESS_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.COMPLIANCE_PROGRESS_SUCCESS:
                return {
                    ...state,
                    isFetching: false,
                    stats: [
                        ...this.getState().stats.filter(getRemoveFilter(action.payload)),
                        ...action.data.map(sanitise)
                    ],
                    error: null
                };

            case ActionTypes.COMPLIANCE_PROGRESS_FAILURE:
                return {
                    ...state,
                    isFetching: false,
                    error: action.data
                };

            default:
                return state;
        }
    }
}

export default new ComplianceProgressStore(Dispatcher);
